export const products = [
  {
    name: "50 Years: Comhairle nan Eilean Siar",
    images: ["assets/img/cnes.jpg"],
    price: 25,
    quantity: 20,
    description:
      "“Ag obair còmhla airson nan Eilean—A journey of achievements and events, 1975–2025.”. Published to mark 50 years of Comhairle nan Eilean.",
  },
  {
    name: "Vatisker Diaries",
    images: ["assets/img/vdiaries_cover.jpg"],
    price: 20,
    quantity: 20,
    description:
      "By Ian Quigley. A distillation of many years’ work, this is a detailed and meticulous history of the village. It traces the people of the village—where they emigrated to, who they married and a hundred other interesting facts that paint a picture of Lewis-as-was.",
  },
  {
    name: "The Gress and Upper Coll Land Raids",
    images: ["assets/img/raiders_frontcover.jpg"],
    price: 10,
    quantity: 200,
    description:
      "By Colin Tucker. A comprehensively-researched look at the land raids in Back between 1919 and 1922 that led to the founding of Gress and Upper Coll.",
  },
  {
    name: "Sgoil a’ Bhac",
    images: ["assets/img/sgoilabhac_cover.jpg"],
    price: 15,
    quantity: 0,
    description:
      "Memories Through the Ages. This book, published in 2014, gathers together stories, photos and information about the 136-year history of Sgoil a’ Bhac and all the pupils and staff who attended it.",
  },
  {
    name: "Gaisgich Sgìre a’ Bhac",
    images: ["assets/img/gaisgich_cover.jpg"],
    price: 15,
    quantity: 0,
    description:
      "A tribute to the fallen of the Back area (Gress to Upper Coll). Combines brief illustrated biographies with background information and poetry.",
  },
  {
    name: "Nine Archaeological Walks",
    images: ["assets/img/archwalks_cover.jpg"],
    price: 10,
    quantity: 50,
    description:
      "This spiral-bound A4 sized book is a compilation of nine reports written by local archaeologist Ian Mchardy. As part of his survey of Sgìre a’ Bhac he led groups of volunteers on walks into the moor, from Gress to Upper Coll. You can read about what they found, and perhaps be inspired to mount expeditions of your own. (The project was made possible by funding from Comhairle nan Eilean’s Crown Estate fund.)",
  },
  {
    name: "Back in Time",
    images: ["assets/img/album24_cover.jpg"],
    price: 5,
    quantity: 50,
    description:
      "A compendium of historical facts and stories, edited by Iain Murray. If you enjoyed the 2023 album this one is even better!",
  },
  {
    name: "Chum Fios Bhi Aig An Al Ri Teachd",
    images: ["assets/img/chum_fios.jpg"],
    price: 6,
    quantity: 0,
    description:
      "The late Neil Murray (Niall Sheumais a’ Ghobha) published this booklet with biographical information about those involved with Back Free Church between 1891 an 1991. Long out-of-print, we are pleased to make it available again.",
  },
  {
    name: "Am Bac (Croft History: Vol 17, Isle of Lewis)",
    images: ["assets/img/bac.jpg"],
    price: 25,
    quantity: 0,
    description: "By Bill Lawson, for Buidhean Eachdraidh a’ Bhac.",
  },
  {
    name: "Bhataisgeir (Croft History: Vol 29, Isle of Lewis)",
    images: ["assets/img/bhataisgeir.jpg"],
    price: 25,
    quantity: 0,
    description: "By Bill Lawson, for Comann Eachdraidh Sgìre a’ Bhac.",
  },
  {
    name: "Col 1-52 (Croft History: Vol 10, Isle of Lewis)",
    images: ["assets/img/col.jpg"],
    price: 25,
    quantity: 0,
    description: "By Bill Lawson, for Buidhean Eachdraidh Chuil.",
  },
  {
    name: "Col 53-88, Col Uarach (Croft History: Vol 11, Isle of Lewis)",
    images: ["assets/img/coluarach.jpg"],
    price: 25,
    quantity: 0,
    description: "By Bill Lawson, for Buidhean Eachdraidh Chuil.",
  },
];

export const euCs = [
  "Austria",
  "Belgium",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Guernsay",
  "Hungary",
  "Ireland",
  "Isle of Man",
  "Jersey",
  "Italy",
  "Latvia",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "Poland",
  "Portugal",
  "Romania",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
  "Switzerland",
];

export const localPostcodes = [
  "HS2 0JP",
  "HS2 0JR",
  "HS2 0JS",
  "HS2 0JN",
  "HS2 0JT",
  "HS2 0JY",
  "HS2 0JZ",
  "HS2 0LA",
  "HS2 0LB",
  "HS2 0LD",
  "HS2 0LE",
  "HS2 0LF",
  "HS2 0LH",
  "HS2 0LJ",
  "HS2 0LQ",
  "HS2 0LN",
  "HS2 0LP",
  "HS2 0LR",
  "HS2 0LS",
  "HS2 0LT",
  "HS2 0LW",
  "HS2 0NA",
  "HS2 0NB",
];

export const sPrices = {
  local: {
    type: "Local Delivery (Back Area)",
    price: 0,
  },
  uk: {
    type: "UK (2nd Class)",
    price: 4.0,
  },
  eu: {
    type: "EU",
    price: 12.0,
  },
  ww: {
    type: "Worldwide",
    price: 17.5,
  },
};
